import { Button, Space, Tabs, Typography } from "antd"
import { useMemberId } from "../.."
import { useNavigate } from "react-router-dom"
import { usePopup } from "utils/use-popup"
import { IEvent } from "../types"
import UnsubscribeModal from "./unsubscribe"
import Layout from "modules/layout/dashboard"
import { useTranslation } from "react-i18next"
import History from "./history"
import Subscriptions from "./subscriptions"
import WaitingList from "./waitingList"
import { useEventsTab } from ".."
import { useMember, useMembers } from "pages/member/queries"
import Presubscriptions from "./presubscriptions"
const { Title } = Typography

const { Main } = Layout
const EventsList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const memberId = useMemberId()
  const activeTab = useEventsTab()
  const unsubscribeModal = usePopup<IEvent>()

  const member = useMember(memberId)
  const members = useMembers()
  // const filters = useMemberEventsFilters()

  return (
    <>
      <Main.PageHeader
        breadcrumbs={[
          { title: member.data?.name!, link: "/" },
          { title: t("events.title") },
        ]}
        hasBackButton={!!members.data && members.data?.length !== 1}
        onButtonClick={() => navigate("/")}
        title={<Title level={3}>{member.data?.name}</Title>}
        rightContent={
          <Space>
            <Button
              size="large"
              type="primary"
              loading={member.isLoading}
              disabled={["unpaid", "inactive"].includes(member.data?.status!)}
              onClick={() => navigate("../registration")}
            >
              {t("events.presubscribe_to_activities")}
            </Button>
          </Space>
        }
      />

      <>
        <Tabs
          activeKey={activeTab}
          onChange={(activeKey) =>
            navigate(`../${activeKey}`, { replace: true })
          }
          items={[
            {
              label: t("events.my_subscriptions"),
              key: "subscriptions",
              children: <Subscriptions />,
            },
            {
              label: t("events.my_presubscriptions"),
              key: "presubscriptions",
              children: <Presubscriptions />,
            },
            {
              label: t("events.waiting_list"),
              key: "waiting_list",
              children: <WaitingList />,
            },
            {
              label: t("events.history"),
              key: "history",
              children: <History />,
            },
          ]}
        />
      </>
      <UnsubscribeModal {...unsubscribeModal} />
    </>
  )
}

export default EventsList
